var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "25px",
    height: "25px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#339af0",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.96094,2.10156c-0.20852,0.00805 -0.4093,0.08112 -0.57422,0.20898l-23,17.90039c-0.29773,0.21363 -0.45479,0.57298 -0.40934,0.93659c0.04544,0.36361 0.28611,0.67326 0.62726,0.80704c0.34115,0.13378 0.72815,0.07028 1.00865,-0.16551l1.38672,-1.08008v27.29102c0.00006,0.55226 0.44774,0.99994 1,1h13.83203c0.10799,0.01785 0.21818,0.01785 0.32617,0h11.67383c0.10799,0.01785 0.21818,0.01785 0.32617,0h13.8418c0.55226,-0.00006 0.99994,-0.44774 1,-1v-27.29102l1.38672,1.08008c0.2805,0.23579 0.6675,0.2993 1.00865,0.16551c0.34115,-0.13378 0.58181,-0.44343 0.62726,-0.80704c0.04544,-0.36362 -0.11161,-0.72297 -0.40935,-0.93659l-23,-17.90039c-0.18607,-0.14428 -0.41707,-0.21828 -0.65234,-0.20898zM25,4.36719l19,14.78711v27.8457h-12v-18c-0.00006,-0.55226 -0.44774,-0.99994 -1,-1h-12c-0.55226,0.00006 -0.99994,0.44774 -1,1v18h-12v-27.8457zM20,30h10v17h-10z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmHome);
export default __webpack_public_path__ + "static/media/sm_home.b91315be04fbbb3685b7968a95c986b3.svg";
export { ForwardRef as ReactComponent };